/**
 * CV dates are free text in the profile editor ("3/2022", "2022-03", "03.2022", "2022"). This
 * turns the common Finnish and international spellings into a month index (year * 12 + month - 1)
 * so the gap rule can compare them. Anything it can't read returns null and the rules treat that
 * entry as "date missing" rather than guessing.
 */
export function parseCvMonth(raw: string, edge: 'start' | 'end' = 'start'): number | null {
  const s = raw.trim();
  if (!s) return null;

  const monthYear = s.match(/^(\d{1,2})\s*[/.\-]\s*(\d{4})$/);
  if (monthYear) return toIndex(Number(monthYear[2]), Number(monthYear[1]));

  const yearMonth = s.match(/^(\d{4})\s*[/.\-]\s*(\d{1,2})$/);
  if (yearMonth) return toIndex(Number(yearMonth[1]), Number(yearMonth[2]));

  const yearOnly = s.match(/^(\d{4})$/);
  if (yearOnly) return toIndex(Number(yearOnly[1]), edge === 'start' ? 1 : 12);

  return null;
}

/** "nyt", "present", "pågående" and an empty end date all mean the role is ongoing. */
const ONGOING = /^(|-|–|now|present|current|ongoing|today|nyt|nykyään|nykyisin|jatkuu|tähän asti|pågående|nu|tills vidare)$/i;

export function isOngoingEnd(raw: string): boolean {
  return ONGOING.test(raw.trim());
}

function toIndex(year: number, month: number): number | null {
  if (year < 1950 || year > 2100 || month < 1 || month > 12) return null;
  return year * 12 + (month - 1);
}
